module.exports = __webpack_public_path__ + "6b491b94d4480b0f0b393b72017f3515.png";